const featureItems = [
  {
    title: '聚合导航',
    desc: '一站式聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门在线视频平台，无需逐一搜索，快速直达目标平台。',
    icon: 'ri-compass-3-line',
    iconBg: 'bg-primary-500',
  },
  {
    title: '持续更新',
    desc: '运营团队每周审核并更新平台收录信息，确保推荐入口保持活跃可用，及时下架失效链接，收录新兴优质视频网站。',
    icon: 'ri-loop-left-line',
    iconBg: 'bg-accent-500',
  },
  {
    title: '安全可靠',
    desc: '所有收录的视频平台均经过基础安全审核，平台入口说明清晰透明，帮助用户避开低质量或存在风险的视频网站。',
    icon: 'ri-shield-check-line',
    iconBg: 'bg-secondary-500',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台优势</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            为什么选择私密视频播放器作为您的视频平台导航
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer text-center"
            >
              <div className={`w-14 h-14 mx-auto rounded-xl ${item.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-xl text-background-50`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}